export default function(source, keys) {
  return Array.from(keys, key => source[key]);
}



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-array/src/permute.js